function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from 'lodash/fp';

var fp = _.noConflict();

export default {
  namespaced: true,
  state: {
    // List of modules that require history. They must implement:
    // - A getter called 'snapshot'
    // - A mutation called 'restoreSnapshot', that will be called with the getter result
    // When creating the snapshot we create a deep copy of the object to avoid mutation
    // of the elements that are already in history (they should be immutable)
    // For similar reasons, we return a copy of the snapshot in current and previous getters,
    // Vue injects their methods in an object to make it reactive. If we return the real
    // snapshot this can cause again unexpected mutations.
    modules: ['api', 'filters', 'elements', 'pagination', 'order', 'groups', 'frequency_groups'],
    results: []
  },
  mutations: {
    push: function push(s, v) {
      return s.results.push(fp.cloneDeep(v));
    },
    back: function back(s) {
      return s.results.pop();
    },
    reset: function reset(s) {
      return s.results = [];
    }
  },
  getters: {
    previous: function previous(s) {
      return s.results.length > 1 ? fp.cloneDeep(s.results[s.results.length - 2]) : null;
    },
    // Back action is allowed only if there is a snapshot of each module
    backAllowed: function backAllowed(s, g) {
      return g.previous && fp.all(function (m) {
        return g.previous[m];
      })(s.modules);
    },
    current: function current(s) {
      return fp.isEmpty(s.results) ? null : fp.cloneDeep(fp.last(s.results));
    },
    snapshot: function snapshot(s, _g, _rs, rg) {
      var addSnapshot = function addSnapshot(result, module) {
        return fp.merge(result, _defineProperty({}, module, rg["".concat(module, "/snapshot")]));
      };

      return fp.reduce(addSnapshot)({})(s.modules);
    }
  },
  actions: {
    set: function set(_ref, externalSnapshot) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit,
          getters = _ref.getters;
      commit('push', externalSnapshot);
      var changedModules = fp.filter(function (m) {
        return !fp.isUndefined(getters.current[m]);
      })(state.modules);
      fp.each(function (m) {
        return commit("".concat(m, "/restoreSnapshot"), getters.current[m], {
          root: true
        });
      })(changedModules);
    },
    push: function push(_ref2) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          getters = _ref2.getters;
      commit('push', getters.snapshot);
    },
    back: function back(_ref3) {
      var state = _ref3.state,
          dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          getters = _ref3.getters;

      if (getters.backAllowed) {
        commit('back');
        fp.each(function (m) {
          return commit("".concat(m, "/restoreSnapshot"), getters.current[m], {
            root: true
          });
        })(state.modules);
      }
    },
    reset: function reset(_ref4) {
      var state = _ref4.state,
          dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          getters = _ref4.getters,
          rootGetters = _ref4.rootGetters;
      commit('reset');
    }
  }
};